import { css } from "theme/default/css";

export const setFlexDFFDCF1 = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
